import React, { useState } from "react";
import AddCategoryModal from "./AddCategoryModal";
import { Pencil } from "lucide-react";

const CategoriesSidebar = ({
  categories,
  activeCategory,
  setActiveCategory,
  onCategoryCreated, // optional: parent callback
  onCategoryUpdated, // optional: parent callback
  activeCategoryId, // ✅ use ID
  setActiveCategoryId, // ✅ use ID
  operatorId,
}) => {
  const [openAdd, setOpenAdd] = useState(false);
  const [editCat, setEditCat] = useState(null);

  return (
    <aside className="hidden md:block w-64 bg-dry text-text rounded-lg">
      <h3 className="text-sm font-semibold mb-4 text-navy">
        Categories ({categories.length})
      </h3>

      <ul className="space-y-2 max-h-[50vh] overflow-y-auto scrollbar-thin border border-gray-300 rounded-lg">
        <ul className="space-y-2 max-h-[50vh] overflow-y-auto scrollbar-thin border border-gray-300 rounded-lg">
          {categories.map((cat) => {
            const isActive =
              activeCategoryId?.toString() === cat._id?.toString();

            return (
              <li
                key={cat._id}
                className={`flex items-center justify-between px-3 py-2 rounded-md text-sm cursor-pointer ${
                  isActive
                    ? "bg-yellowstar font-medium text-navy"
                    : "hover:border"
                }`}
                style={isActive ? { color: cat.color } : {}}
                onMouseEnter={(e) => {
                  if (!isActive) {
                    // ✅ FIX
                    e.currentTarget.style.backgroundColor = "#edf2f7";
                    e.currentTarget.style.color = cat.color;
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isActive) {
                    // ✅ FIX
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.color = "";
                  }
                }}
                onClick={
                  () => setActiveCategoryId(cat._id.toString()) // ✅ normalize
                }
              >
                <span>{cat.name}</span>

                <div className="flex items-center gap-2">
                  <span className="text-xs text-navy">{cat.count ?? 0}</span>

                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setEditCat(cat);
                      setOpenAdd(true);
                    }}
                  >
                    <Pencil size={12} className="text-textGray" />
                  </button>
                </div>
              </li>
            );
          })}
        </ul>
      </ul>

      <button
        className="mt-4 text-sm text-redlight hover:underline"
        onClick={() => {
          setEditCat(null);
          setOpenAdd(true);
        }}
      >
        + Add category
      </button>

      <AddCategoryModal
        open={openAdd}
        category={editCat} // null = Add, object = Edit
        onClose={() => {
          setOpenAdd(false);
          setEditCat(null);
        }}
        onCreated={(newCat) => {
          onCategoryCreated?.(newCat);
        }}
        onUpdated={(updated) => {
          onCategoryUpdated?.(updated);
        }}
        operatorId={operatorId}
      />
    </aside>
  );
};

export default CategoriesSidebar;
